import { isFlagEnabled } from "js/utilities";
import { Link } from "react-router-dom";

export default function CallToActionCardWithIconOnTop({
  action = "link",
  actionMethod,
  icon,
  title,
  desc,
  ctaUrl,
  ctaText,
  ctaSrText,
  subAction = false,
  phoneNumber,
  phoneNumberForAnnuity,
  phoneNumberForVariableAnnuity,
  isActionAtTheBottom = false,
}) {
  const getPhoneNumbers = () => {
    if (isFlagEnabled("ENABLE_ANNUITIES")) {
      return (
        <>
          <div className="whitespace-nowrap">{`Life: ${phoneNumber}`}</div>
          <div className="pt-2">
            {`Fixed Annuity: ${phoneNumberForAnnuity}`}
          </div>
          {phoneNumberForVariableAnnuity && (
            <div className="pt-2 whitespace-nowrap">
              {`Variable Annuity: ${phoneNumberForVariableAnnuity}`}
            </div>
          )}
        </>
      );
    } else {
      return (
        <span>
          Or call{" "}
          <a className="whitespace-nowrap" href={`tel:+1-${phoneNumber}`}>
            {phoneNumber}
          </a>
        </span>
      );
    }
  };
  return (
    <div className="ui-card p-4 xl:p-6 h-full">
      <div className="grid grid-cols-1 grid-rows-[min-content,min-content] h-full text-center content-between">
        <div className="grid grid-cols-1 gap-4">
          <div className="place-self-center">
            <svg
              className="ui-icon w-6 h-6 text-ui-blue"
              focusable="false"
              aria-hidden="true"
              role="presentation"
            >
              <use href={icon}></use>
            </svg>
          </div>
          <div className="font-body font-bold text-xl">{title}</div>
          {!isActionAtTheBottom && (
            <div>
              {action === "link" && (
                <Link to={ctaUrl} className="mt-2 ui-btn-primary ui-btn-min-w">
                  {ctaText}
                  {ctaSrText && <span className="sr-only"> {ctaSrText}</span>}
                </Link>
              )}
              {action === "modal" && (
                <button
                  className="mt-2 ui-btn-primary ui-btn-min-w"
                  onClick={actionMethod}
                >
                  {ctaText}
                </button>
              )}
              {action === "fax" && <div>{ctaText}</div>}
            </div>
          )}
          <div className="text-sm">{desc}</div>
          {isActionAtTheBottom && (
            <div>
              {action === "link" && (
                <Link to={ctaUrl} className="mt-2 ui-btn-primary ui-btn-min-w">
                  {ctaText}
                  {ctaSrText && <span className="sr-only"> {ctaSrText}</span>}
                </Link>
              )}
              {action === "modal" && (
                <button
                  className="mt-2 ui-btn-primary ui-btn-min-w"
                  onClick={actionMethod}
                >
                  {ctaText}
                </button>
              )}
              {action === "fax" && <div>{ctaText}</div>}
            </div>
          )}
        </div>
        {subAction === "phone" && (
          <div className="text-sm">
            &nbsp;
            {getPhoneNumbers()}
            &nbsp;
          </div>
        )}
      </div>
    </div>
  );
}
